var React = require('react');

function SuggestProducts (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.017 0.057)"},[React.createElement("path",{"d":"M62.979,83.333a33.333,33.333,0,1,1,4.112-29.167","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4.167","key":0}),React.createElement("path",{"d":"M37.021,16.667a33.333,33.333,0,1,1-4.1,29.167","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4.167","key":1})]));
}

SuggestProducts.defaultProps = {"width":"100.041","height":"100.106","viewBox":"0 0 100.041 100.106"};

module.exports = SuggestProducts;

SuggestProducts.default = SuggestProducts;
